import { PaymentType, PeriodType, MemberLevel } from './types';

/**
 * 获取支付类型文本
 */
export const getPaymentTypeText = (type: PaymentType): string => {
  const typeMap: Record<PaymentType, string> = {
    [PaymentType.APPLE_PAY]: 'Apple Pay',
    [PaymentType.GOOGLE_PAY]: 'Google Pay',
  };
  return typeMap[type] || '未知';
};

/**
 * 获取产品类型文本
 */
export const getPeriodTypeText = (type: PeriodType): string => {
  const typeMap: Record<PeriodType, string> = {
    [PeriodType.MONTH]: '月',
    [PeriodType.HALF_YEAR]: '半年',
    [PeriodType.YEAR]: '年',
    [PeriodType.QUARTER]: '季度',
  };
  return typeMap[type] || '未知';
};

/**
 * 获取会员等级文本
 */
export const getMemberLevelText = (level: MemberLevel | number): string => {
  const levelMap: Record<number, string> = {
    [MemberLevel.STANDARD]: 'Pro',
    [MemberLevel.PREMIUM]: 'Premium',
    [MemberLevel.BASIC]: 'Basic',
    [MemberLevel.LITE]: 'Lite',
  };
  return levelMap[level] || '未知';
};

/**
 * 获取状态文本和颜色
 */
export const getStatusInfo = (status: number) => {
  const statusMap: Record<number, { text: string; color: string }> = {
    0: { text: '禁用', color: 'error' },
    1: { text: '启用', color: 'success' },
  };
  return statusMap[status] || { text: '未知', color: 'default' };
};

